export type LayoutGate = "loading" | "error" | "onboarding" | "choose-workspace" | "render";

// Decides what AppLayout may render before the app shell is safe to show.
// Pure so the branching is unit-testable without mounting the layout tree.
export function resolveLayoutGate({
  loading,
  isAuthenticated,
  currentUser,
}: {
  loading: boolean;
  isAuthenticated: boolean;
  currentUser: { isOnboarded?: boolean | null; workspaces?: unknown[] | null } | undefined;
}): LayoutGate {
  if (!currentUser) {
    // Still resolving, or unauthenticated (AuthGate is about to redirect to
    // /login) — show the loader. Only a settled, authenticated session with
    // no user means the `me` query failed and a retry should be offered.
    if (loading || !isAuthenticated) return "loading";
    return "error";
  }
  if (currentUser.isOnboarded === false) return "onboarding";
  if (!currentUser.workspaces?.length) return "choose-workspace";
  return "render";
}
